import { stopBatchQueueForSession } from './batch-queue';
import { requestCloudMirrorRetryCancel } from './cloud-mirror-events';
import { closeLocalTenantDatabase } from './db';
import { stopUploadQueue } from './upload-queue';

let shutdownPromise: Promise<void> | null = null;

/**
 * Fence every tenant-owned local worker before closing the verified Dexie
 * namespace. Callers may invoke this repeatedly during logout races; all calls
 * share the same completion boundary.
 */
export function shutdownLocalTenantRuntime(): Promise<void> {
    if (shutdownPromise) return shutdownPromise;

    // FileExplorer owns the PipelineRunner AbortController. Abort it
    // synchronously before the durable queue begins waiting for its run loop.
    try {
        window.dispatchEvent(new CustomEvent('qm-batch-queue-abort-requested'));
    } catch { /* non-browser tests and sealed event targets */ }
    // A cloud mirror waiting out a quota refusal would otherwise send its
    // retry after sign-out, with no session (s3-sync.ts).
    requestCloudMirrorRetryCancel();

    shutdownPromise = (async () => {
        await Promise.allSettled([
            stopUploadQueue(),
            stopBatchQueueForSession(),
        ]);
        closeLocalTenantDatabase();
    })();
    return shutdownPromise;
}

export function __resetLocalSessionRuntimeForTests(): void {
    shutdownPromise = null;
}
